@if (data()) {
  <footer
    class="bottom-0 z-20 flex flex-col lg:flex-row items-end w-full"
    [class]="positionFooter()"
    >
    <div
      class="lg:absolute flex p-6 w-full justify-between items-end order-1 lg:order-none"
      >
      <p
        [hidden]="!siteInfo"
        [innerHtml]="data().copyright"
        class="lg:absolute bottom-5 right-12 text-white fade"
      ></p>
      <button
        (click)="displaySiteInfo()"
        class="lg:absolute bottom-5 right-5 cursor-pointer ml-auto has-tooltip"
        [ngClass]="siteInfo ? 'is-open' : ''"
        aria-label="Toggle site information"
        >
        <span
          class="tooltip rounded shadow-lg p-2 bg-black bg-opacity-40 text-white"
          >Show/hide site info</span
          >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="stroke-current text-yellow-200 hover:text-blue-600 w-6 h-6"
            >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </button>
        </div>
        <div
          [hidden]="!siteInfo"
          class="relative md:container lg:w-auto lg:bottom-5 lg:left-10 text-white p-6 bg-black bg-opacity-40 rounded-xl fade"
          >
          <ul class="mb-3">
            <li>Built with:</li>
            @for (item of data().buildTools; track item) {
              <li [innerHtml]="item"></li>
            }
          </ul>
          <ul>
            <li>Plugins, effects and external resources:</li>
            @for (item of data().resources; track item) {
              <li [innerHtml]="item"></li>
            }
          </ul>
          <!-- <ul>
          <li>Website versions:</li>
          <li *ngFor="let item of data.siteVersions" [innerHtml]="item"></li>
        </ul> -->
      </div>
    </footer>
  }
